// extracted by mini-css-extract-plugin
export var $animation_name = "Clamp-module--$animation_name--758aa";
export var Clamp = "Clamp-module--Clamp--aa847";
export var Clamp__gallery = "Clamp-module--Clamp__gallery--9ae0c";
export var Clamp__text = "Clamp-module--Clamp__text--6b746";
export var Inner = "Clamp-module--Inner--21f0c";
export var StickyElement = "Clamp-module--StickyElement--e6c99";